import { FieldParameter } from "@fartherfinance/frontend/api/TaskWorkflows/Types";

import { TaskPriorityEnhancer } from "./TaskPriorityEnhancer";
import { TaskStatusEnhancer } from "./TaskStatusEnhancer";
import { FieldEnhancementConfig, FieldEnhancer } from "./types";

class FieldEnhancementRegistry {
  private enhancers: FieldEnhancer[] = [
    TaskPriorityEnhancer,
    TaskStatusEnhancer,
  ];

  /**
   * Register a new field enhancer
   * @param enhancer The enhancer to register
   */
  register(enhancer: FieldEnhancer): void {
    this.enhancers.push(enhancer);
  }

  /**
   * Get all registered enhancers (useful for debugging)
   */
  getRegisteredEnhancers(): readonly FieldEnhancer[] {
    return this.enhancers;
  }

  /**
   * Get enhancement configuration for a field
   * @param fieldParameter The field parameter to check
   * @param currentValue The current value of the field
   * @returns Enhancement config if a matching enhancer is found, null otherwise
   */
  getEnhancement(
    fieldParameter: FieldParameter,
    currentValue: string | undefined
  ): FieldEnhancementConfig | null {
    const enhancer = this.enhancers.find((e) => e.matches(fieldParameter));
    return enhancer ? enhancer.getConfig(currentValue) : null;
  }

  /**
   * Check if a field has any enhancements available
   * @param fieldParameter The field parameter to check
   * @returns true if enhancements are available, false otherwise
   */
  hasEnhancement(fieldParameter: FieldParameter): boolean {
    return this.enhancers.some((e) => e.matches(fieldParameter));
  }
}

// Export a singleton instance
export const fieldEnhancementRegistry = new FieldEnhancementRegistry();
